<template>
    <div class="overview-overlay" style="display: block; position: relative; top:0; background-color: #000; padding-bottom: 100px;">
        <template v-if="!loading">
            <div class="container">
            <div class="row">
                <div class="price text-white text-right" style="font-size: 30px;">${{buildPrice}}</div>
            </div>
            <div class="row">
                <div class="col-md-4 col-xs-12">
                    <div class="row final-review" style="display: block;">
                        <div class="col-md-12">
                            <h2 class="text-left">USER BUILD</h2>
                        </div>
                    </div>
                    <div class="fps-graphing">
                        <template v-if="builds[0]">
                            <div class="fps-graphing-item" rel="game_0" v-for="games in builds[0].performance">
                                <img class="img-responsive" :src="games.images">
                                <div class="fps-graphing-item-fps">
                                    <div class="fps-text">{{games.game_value}}<span>fps</span>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="part-name opacity">XXX</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left opacity"></div>
                            <div class="col-md-4 part-price text-right opacity"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-xs-6">
                    <div class="part-item part-item-1">
                        <div class="part-name">CASE:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(1).products ? getElementInArray(1).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-2">
                        <div class="part-name">POWER:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(6).products ? getElementInArray(6).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-3">
                        <div class="part-name">GPU:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(7).products ? getElementInArray(7).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-4">
                        <div class="part-name">CPU:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(3).products ? getElementInArray(3).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-5">
                        <div class="part-name">MOTHERBOARD:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(2).products ? getElementInArray(2).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-6">
                        <div class="part-name">RAM:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(10).products ? getElementInArray(10).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-7">
                        <div class="part-name">SSD:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(4).products ? getElementInArray(4).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-8 hide">
                        <div class="part-name">HDD:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left"></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 col-xs-6">
                    <div class="part-item part-item-cpu-cooling">
                        <div class="part-name">CPU COOLING:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(12).products ? getElementInArray(12).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="part-item part-item-fans hide">
                        <div class="part-name">FANS:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left"></div>
                        </div>
                    </div>
                    <div class="part-item part-item-gpuextra hide">
                        <div class="part-name">POWER UPGRADES:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left"></div>
                        </div>
                    </div>
                    <div class="part-item part-item-extra hide">
                        <div class="part-name">EXTRA:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left"></div>
                        </div>
                    </div>
                    <div class="part-item part-item-software">
                        <div class="part-name">SOFTWARE:</div>
                        <div class="row">
                            <div class="col-md-8 part-label text-left">
                                <p class="0">
                                    {{getElementInArray(5).products ? getElementInArray(5).products.name : 'N/A'}}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="share-button">
                        <div class="row">
                            <div class="col-md-12">
                                <router-link class="purchase btn btn-purple btn-block" :to="{ name: 'step1' }">build your own</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </template>
        <template v-else>
            <div class="container">
                <div class="row">
                    <div style="text-align:center">
                        <span class="fa fa-spin fa-spinner"></span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "UserBuild",
        data() {
            return {
                builds: [],
                buildNumber: '',
                buildPrice: '',
                loading: true,
            }
        },
        created() {
            this.buildNumber = this.$route.params.build_number;
            this.getBuilds();
            $('body').addClass("bg-black");
        },
        methods: {
            getBuilds() {
                axios({
                    url: `/drafts/${this.buildNumber}?relationships=products,performance`,
                    method: "GET"
                }).then(builds => {
                    this.builds = builds.data.data;
                    this.buildPrice = builds.data.total_price;
                    this.loading = false;
                }).catch(error => {
                    this.$router.push({ name: 'NotFound'});
                })
            },
            getElementInArray(moduleId) {
                if (this.builds.length) {
                    return this.builds.find((product) => {
                        return product.product_modules_id == moduleId;
                    });
                } else {
                    return [];
                }
            }
        }
    }
</script>
